/**
 * Example: deUrnify('urn:ue:toolbox:123456') returns '{nid: "toolbox", nss: "123456"}'
 */
export const deUrnify = (urn) => {
    const [nid, nss] = urn.replace('urn:ue:', '').replace('::', ':').split(':');
    return {nid, nss};
};
